
import config from './data'
import resolveProps from '../../utils/resolveProps'

export type inputTypeProps = {
  title?: string,
  type?: string,
  pattern?: RegExp | string,
  mask?: [] | string ,
  icons?: string | [],
  fn?: (value?: string, message?: string) => {
    hasError?: boolean,
    message?: string
  }
}

const InitialState = {
  title: 'text',
  type: 'text'
}


export default function useInput(keys: string[]) {

  return {
    mdnClasses: resolveProps(keys, config, 'Input'),
    inputType: config.filter(it => keys.includes(it.title))
      .reduce((_, item) => ({ ...item })) || InitialState,
  }
}
